module.exports = __webpack_public_path__ + "img/drInfo-logo.1eb25b34.png";